import moment from 'moment';
import React from 'react';
import { Link } from 'react-router-dom';
import { l10n } from '../../i18n/Localization';

const CharacterViewPrimaryPart = (props) => {
    const { className, character, showingToOwner } = props;

    const editCharacterUrl = `/characters/${character.id}/edit`;
    const verifyCharacterUrl = `/characters/${character.id}/verify`;
    const refreshCharacterGameDataUrl = `/characters/${character.id}/refresh-game-data`;

    return (
        <div className={className}>
            {
                showingToOwner ? (
                    <div>
                        <Link className="btn btn-primary btn-sm" to={editCharacterUrl}>
                            <i className="bi-pencil-fill"></i>
                        </Link>
                    </div>
                ) : null
            }
            <div>{l10n.characterViewPart.game}: {character.gameCode.wireName}</div>
            <div>{l10n.characterViewPart.identificationName}: {character.identificationName}</div>
            <div>{l10n.characterViewPart.verificationNumber}: {character.verificationNumber}</div>
            <div className="d-flex align-items-center">
                <div>{l10n.characterViewPart.isVerified}: {character.isVerified ? l10n.yes : l10n.no}</div>
                {
                    showingToOwner ? (
                        !character.isVerified ? (
                            <div className="ml-3">
                                <Link className="btn btn-primary btn-sm" to={verifyCharacterUrl}>
                                    <i className="bi-person-check-fill mr-2"></i>{l10n.action.verify}
                                </Link>
                            </div>
                        ) : null
                    ) : null
                }
            </div>
            <div className="d-flex align-items-center">
                <div>{l10n.characterViewPart.gameDataRefreshedAt}: {character.gameDataRefreshedAt !== null ? moment(character.gameDataRefreshedAt).calendar() : null}</div>
                {
                    showingToOwner ? (
                        character.isVerified ? (
                            <div className="ml-3">
                                <Link className="btn btn-primary btn-sm" to={refreshCharacterGameDataUrl}>
                                    <i className="bi-arrow-clockwise mr-2"></i>{l10n.action.refreshGameData}
                                </Link>
                            </div>
                        ) : null
                    ) : null
                }
            </div>
        </div>
    );
};

const CharacterViewDateTimePart = (props) => {
    const { className, character } = props;

    return (
        <div className={className}>
            <div>{l10n.characterViewPart.createdAt}: {moment(character.createdAt).calendar()}</div>
            <div>{l10n.characterViewPart.updatedAt}: {moment(character.updatedAt).calendar()}</div>
        </div>
    );
};

export { CharacterViewPrimaryPart, CharacterViewDateTimePart };
